import {
  faCode,
  faFutbolBall,
  faGamepad,
  faNetworkWired,
  faSignal,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import {
  AboutBodyLeft,
  AboutBodyRight,
  AboutNavLink,
  AboutContainer,
  Page,
  PageBody,
  ResumeExpItem,
  InterestPanelHeaderTitle,
  PageHeading,
  PageHeadingText,
} from '../components/styled';

const sections = [
  {
    section: 'skills',
    component: (
      <>
        <ResumeExpItem>
          <span>Telecommunications Systems</span>
          <h6>3GPP (2G, 3G, 4G LTE) systems, IP networks, VoIP systems.</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>Software Development</span>
          <h6>Systems development (C/C++, Python) , Web development (Nodejs, React)</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>Embedded Platforms development</span>
          <h6>
            Microprocessors (Arduino, Raspberry PI, electric IMP) and Sensor/ Actuator based
            development.
          </h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>Network Protocols and Stacks</span>
          <h6>TCP/IP, Mobile (GSM, WCDMA, LTE)</h6>
          <h6>Standards: IETF, IEEE, 3GPP</h6>
          <h6>Routing Protocols, WAN &LAN network topologies.</h6>
        </ResumeExpItem>
      </>
    ),
  },
  {
    section: 'experience',
    component: (
      <>
        <ResumeExpItem>
          <span>2021 - Current</span>
          <h6>Software Engineer Networking at Softdrive Inc.</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>2020 - 2021</span>
          <h6>Software Engineer WebRTC at AgilityFeat</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>2018 - 2020</span>
          <h6>Software Engineer at DataRemote Inc</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>2017 - 2020</span>
          <h6>Software Developer / Devops Engineer at Bitt Inc</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>2015 - 2017</span>
          <h6>Senior Core Network Engineer at Digicel Limited</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>2011 - 2014</span>
          <h6>Senior Network Analyst at Republic Bank (Barbados) Ltd</h6>
        </ResumeExpItem>
      </>
    ),
  },
  {
    section: 'education',
    component: (
      <>
        <ResumeExpItem>
          <span>2010</span>
          <h6>Masters of Science - Wireless Communications</h6>
          <h6>University of Southampton – Southampton, United Kingdom</h6>
        </ResumeExpItem>
        <ResumeExpItem>
          <span>2006</span>
          <h6>Bachelors of Science – Computer Science &amp; Electronics</h6>
          <h6>University of the West Indies – Bridgetown, Barbados</h6>
        </ResumeExpItem>
      </>
    ),
  },
  {
    section: 'interests',
    component: (
      <>
        <ResumeExpItem>
          <InterestPanelHeaderTitle>
            <div>
              <FontAwesomeIcon icon={faCode} />
            </div>
            <h6>Programming</h6>
          </InterestPanelHeaderTitle>
        </ResumeExpItem>
        <ResumeExpItem>
          <InterestPanelHeaderTitle>
            <div>
              <FontAwesomeIcon icon={faSignal} />
            </div>
            <h6>Communications</h6>
          </InterestPanelHeaderTitle>
        </ResumeExpItem>
        <ResumeExpItem>
          <InterestPanelHeaderTitle>
            <div>
              <FontAwesomeIcon icon={faNetworkWired} />
            </div>
            <h6>Networking</h6>
          </InterestPanelHeaderTitle>
        </ResumeExpItem>
        <ResumeExpItem>
          <InterestPanelHeaderTitle>
            <div>
              <FontAwesomeIcon icon={faGamepad} />
            </div>
            <h6>Gaming</h6>
          </InterestPanelHeaderTitle>
        </ResumeExpItem>
        <ResumeExpItem>
          <InterestPanelHeaderTitle>
            <div>
              <FontAwesomeIcon icon={faFutbolBall} />
            </div>
            <h6>Sports</h6>
          </InterestPanelHeaderTitle>
        </ResumeExpItem>
      </>
    ),
  },
];

const AboutSectionBody = ({ item }) => {
  return <div>{item.component}</div>;
};

export const About = forwardRef(({ height }, ref) => {
  const [activeKey, setActiveKey] = useState('skills');
  const activeSection = sections.filter(section => section.section === activeKey)[0];

  return (
    <AboutContainer ref={ref} height={height} id="about">
      <Page>
        <PageBody>
          <AboutBodyLeft />
          <AboutBodyRight>
            <PageHeading>
              <PageHeadingText>About Me</PageHeadingText>
            </PageHeading>
            <p>
              I am a proud Barbadian 🇧🇧 with a passion for technology. I have spent all my career in
              a tech field whether it be networking or development. This career now spans over the
              ten years and continues to grow. My academic studies were also in the tech field ,in
              the area of Computer Science and Digital Communications, and I consider myself lucky
              to have been able to find a career in an area I hold such passion for. For me the
              ideal tech areas are at the intersection of networking and development. Coding common
              computer standards has become someone what of a pastime. Though I have been in tech
              for a while, I still enjoying learning new things and taking on interesting problems.
            </p>
            <Nav
              style={{ marginBottom: 5 }}
              defaultActiveKey={activeKey}
              onSelect={eventKey => setActiveKey(eventKey)}
            >
              <AboutNavLink active={activeKey === 'skills'} eventKey="skills">
                Skills
              </AboutNavLink>
              <AboutNavLink active={activeKey === 'experience'} eventKey="experience">
                Experience
              </AboutNavLink>
              <AboutNavLink active={activeKey === 'education'} eventKey="education">
                Education
              </AboutNavLink>
              <AboutNavLink active={activeKey === 'interests'} eventKey="interests">
                Interest
              </AboutNavLink>
            </Nav>
            <AboutSectionBody item={activeSection} />
          </AboutBodyRight>
        </PageBody>
      </Page>
    </AboutContainer>
  );
});
